export default "__VITE_ASSET__BXIZoNX2__"